"use client";

import ScrollReveal from "@/components/common/ScrollReveal";
import BorderedHeading from "@/components/common/BorderedHeading";
import Image from "next/image";

const partners = [
  {
    name: "Skillspar",
    logo: "/images/Company/skillspar.svg",
    url: "https://www.skillspar.com/",
  },
  {
    name: "Vector Infotech",
    logo: "/images/Company/vector-infotech.svg",
    url: "https://www.vectorinfotech.com/",
  },
  {
    name: "Khaicode",
    logo: "/images/Company/khaicode.svg",
    url: "https://www.khaicode.com",
  },
];

export default function AboutUs() {
  return (
    <section className="w-full px-4 sm:px-6 lg:px-8 pt-2 pb-12">
      <div className="w-full max-w-[1300px] mx-auto">
        <ScrollReveal direction="up">
          <div className="max-w-[644px] mb-12 md:mb-16">
            <p className="text-white text-[15px] md:text-base leading-[26px] md:leading-[28px] tracking-[0.5px] mb-4 md:mb-7">
              ECQ is a network security company offering offensive security
              services and solutions focused on active offensive and defensive
              positioning. Since its establishment, ECQ provides superior
              consultancy services to clients in many different industries,
              including financial sector, infrastructure, service providers and
              government agencies.
            </p>
            <p className="text-white text-[15px] md:text-base leading-[26px] md:leading-[28px] tracking-[0.5px]">
              ECQ is highly trusted by many enterprises internationally to
              provide in-depth security assessment, highly resilient security
              designs, and innovative security technologies. With its current
              presence in the Singapore, Thailand, Vietnam, and USA, ECQ aims to
              continuously deliver high quality security services to many diverse
              customers around the globe.
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={100}>
          <div className="flex items-center gap-4 mb-6">
            <BorderedHeading
              as="h2"
              variant="headline-4"
              className="text-white font-semibold whitespace-nowrap"
            >
              Partners
            </BorderedHeading>
            <div className="flex-1 h-px bg-white/15" />
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={200}>
          <div className="flex flex-wrap gap-4 md:gap-6">
            {partners.map((p) => (
              <a
                key={p.name}
                href={p.url}
                target={p.url === "#" ? undefined : "_blank"}
                rel={p.url === "#" ? undefined : "noopener noreferrer"}
                className="flex items-center justify-center w-[160px] h-[160px] md:w-[200px] md:h-[200px] rounded-xl border-[1.5px] border-[rgba(151,151,151,0.4)] hover:border-primary/40 transition-colors"
              >
                <Image
                  src={p.logo}
                  alt={p.name}
                  width={140}
                  height={48}
                  className="object-contain max-h-[60px] px-4"
                  unoptimized
                />

              </a>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
